"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ResultsView;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ResultsView(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "View_manipulation",
    "data-name": "View manipulation"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "results-view"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline",
    d: "M88,46.834H72.271a4.505,4.505,0,0,1-4.5-4.5V17.426a4.5,4.5,0,0,1,4.5-4.5H88a4.5,4.5,0,0,1,4.5,4.5V42.334A4.505,4.505,0,0,1,88,46.834Zm-15.229-5H87.5V17.926H72.771ZM88,87.074H72.271a4.5,4.5,0,0,1-4.5-4.5V57.666a4.505,4.505,0,0,1,4.5-4.5H88a4.505,4.505,0,0,1,4.5,4.5V82.574A4.5,4.5,0,0,1,88,87.074Zm-15.229-5H87.5V58.166H72.771ZM57.864,46.834H42.136a4.5,4.5,0,0,1-4.5-4.5V17.426a4.5,4.5,0,0,1,4.5-4.5H57.864a4.5,4.5,0,0,1,4.5,4.5V42.334A4.5,4.5,0,0,1,57.864,46.834Zm-15.228-5H57.364V17.926H42.636Zm15.228,45.24H42.136a4.5,4.5,0,0,1-4.5-4.5V57.666a4.5,4.5,0,0,1,4.5-4.5H57.864a4.5,4.5,0,0,1,4.5,4.5V82.574A4.5,4.5,0,0,1,57.864,87.074Zm-15.228-5H57.364V58.166H42.636ZM27.729,46.834H12a4.505,4.505,0,0,1-4.5-4.5V17.426a4.5,4.5,0,0,1,4.5-4.5H27.729a4.5,4.5,0,0,1,4.5,4.5V42.334A4.505,4.505,0,0,1,27.729,46.834Zm-15.229-5H27.229V17.926H12.5Zm15.229,45.24H12a4.5,4.5,0,0,1-4.5-4.5V57.666a4.505,4.505,0,0,1,4.5-4.5H27.729a4.505,4.505,0,0,1,4.5,4.5V82.574A4.5,4.5,0,0,1,27.729,87.074Zm-15.229-5H27.229V58.166H12.5Z"
  }))));
}